/*
 * @Author: withease-partner+cao@hashdash-group.com
 * @Description: the frame page of 「只能输入数字的输入框」
 * @modify Date:2021.2.17 15:22
 */
<template>
  <div class="cNumInput-container">
    <input
      :type=" isTel?'tel':'number' "
      :disabled="disabled"
      :placeholder="placeholder"
      :value="value"
      :class="{ error: formatError, inputEdited: value }"
      autocomplete="off"
      pattern="[0-9]*"
      onkeyup="value=value.replace(/[^\d０-９]/g,'')"
      :oninput="oninput"
      @blur="handleblur"
      @focus="handleComposing"
      @input="$emit('input', $event.target.value.trim())"
    />
    <p v-if="formatError && message" class="inputMessage" v-html="$sanitize(message)"></p>
  </div>
</template>

<script>
export default {
  name: 'InputItem',
  props: [
    'value',
    'placeholder', //提示信息
    'message', //错误信息
    'formatError',
    'disabled',
    'oninput', //限制长度
    'isTel'
  ],
  computed: {
    text() {
      return '';
    }
  },
  methods: {
    //正在输入
    handleComposing() {
      this.$emit('update:formatError', false);
    },
    // 失去焦点，校验信息
    handleblur() {
      this.$emit('blur');
    }
  }
};
</script>
<style scoped lang="less">
.cNumInput-container {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  position: relative;
  input {
    height: 0.5rem;
    background: var(--bg-pinkcolor);
    border: 2px solid var(--maincolor);
    font-size: 0.16rem;
    line-height: 0.5rem;
    color: var(--text-graycolor);
    padding: 0 0.14rem;
    width: 100%;
    border-radius: 5px;
  }
  .inputEdited {
    background-color: #ffffff;
    color: #333333;
  }
  .error {
    border: 1px solid red;
  }
  .inputMessage {
    padding: 0 0.05rem;
    color: red;
    font-size: 0.12rem;
    line-height: 0.14rem;
    min-height: 0.28rem;
    white-space: pre-wrap;
    margin-top: 0.05rem;
    position: absolute;
    top: 0.5rem;
  }
  input[type='number']::-webkit-outer-spin-button,
  input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Input/cNumInput.vue